import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { loginUser } from '@/lib/api';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const [search] = useSearchParams();
  const returnTo = search.get('returnTo') || '/account';

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await loginUser({ email, password });
      localStorage.setItem('pd_user_token', r.token);
      localStorage.setItem('pd_user', JSON.stringify(r.user));
      toast.success('Signed in.');
      nav(returnTo, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Sign-in failed.');
    } finally { setLoading(false); }
  };

  return (
    <div className="container-pd py-16 max-w-md" data-testid="login-page">
      <div className="font-mono text-[10px] text-[color:var(--pd-gold)] uppercase tracking-[0.2em]">Account</div>
      <h1 className="font-display text-5xl leading-none mt-3">Sign in.</h1>
      <p className="text-muted-sage mt-3 text-sm">All entries — paid and free postal — require an account. New here?{' '}
        <Link to={`/register?returnTo=${encodeURIComponent(returnTo)}`} className="text-[color:var(--pd-accent-yellow)]">Create one in a minute</Link>.
      </p>
      <form onSubmit={submit} className="mt-6 space-y-3" data-testid="login-form">
        <input required type="email" placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full h-12 rounded-xl bg-surface border border-pd px-4 text-sm focus:border-[color:var(--pd-accent-yellow)] focus:outline-none" data-testid="login-email" />
        <input required type="password" placeholder="Password" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full h-12 rounded-xl bg-surface border border-pd px-4 text-sm focus:border-[color:var(--pd-accent-yellow)] focus:outline-none" data-testid="login-password" />
        <button disabled={loading} className="w-full bg-[color:var(--pd-accent-yellow)] text-[#14251c] rounded-xl px-4 py-3.5 font-medium disabled:opacity-60" data-testid="login-submit">
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
        <div className="pt-1 text-center">
          <Link
            to="/forgot-password"
            className="text-sm text-muted-sage hover:text-[color:var(--pd-accent-yellow)] underline underline-offset-4"
            data-testid="login-forgot-password-link"
          >
            Forgot your password?
          </Link>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
